var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickcircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1539 3.2063C8.03702 3.2063 3.05249 8.19083 3.05249 14.3077C3.05249 20.4246 8.03702 25.4091 14.1539 25.4091C20.2708 25.4091 25.2553 20.4246 25.2553 14.3077C25.2553 8.19083 20.2708 3.2063 14.1539 3.2063ZM19.4604 11.7544L13.1659 18.0489C13.0104 18.2043 12.7995 18.2931 12.5775 18.2931C12.3555 18.2931 12.1445 18.2043 11.9891 18.0489L8.84742 14.9072C8.52548 14.5852 8.52548 14.0524 8.84742 13.7304C9.16936 13.4085 9.70223 13.4085 10.0242 13.7304L12.5775 16.2837L18.2836 10.5776C18.6055 10.2557 19.1384 10.2557 19.4604 10.5776C19.7823 10.8996 19.7823 11.4213 19.4604 11.7544Z",
    fill: "#662AB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickcircle);
export default __webpack_public_path__ + "static/media/tickcircle.57fd2fca40da90d709f147b15264a76c.svg";
export { ForwardRef as ReactComponent };